<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-form ref="CoreTimeFormref" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span>IPCR Rating</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeD()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-card>
              <v-row>
                <v-col
                  cols="12"
                  v-if="targetRating && targetRating.isSubmitted == 1"
                >
                  <v-stepper alt-labels class="elevation-0">
                    <v-stepper-header>
                      <v-stepper-step
                        step="1"
                        class="pa-5"
                        :complete="
                          targetRating && targetRating.assesed_by_status == 2
                            ? true
                            : false
                        "
                        :rules="[
                          () =>
                            targetRating && targetRating.assesed_by_status != 3,
                        ]"
                        color="#6DB249"
                      >
                        {{
                          getName(
                            targetRating && targetRating.assesed_by
                              ? targetRating.assesed_by
                              : null
                          )
                        }}
                        <small>Assessed By<br /> </small>
                      </v-stepper-step>
                    </v-stepper-header>
                  </v-stepper>
                </v-col>
                <v-col cols="8" class="flex-items mt-2">
                  <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                    <v-tab
                      v-for="tab in tabList"
                      :key="tab.id"
                      @click="changeTab(tab)"
                      >{{ tab.name }}</v-tab
                    >
                  </v-tabs>
                </v-col>
                <v-spacer></v-spacer>

                <v-col cols="12" class="pt-2 px-4" v-if="tab != 3">
                  <v-data-table
                    :headers="headers"
                    :items="dataItem"
                    :items-per-page="-1"
                    :item-class="setPendingClass"
                  >
                    <template v-slot:[`item.efficiency`]="{ item }">
                      {{
                        item.facultyRating.accomplishment
                          ? "(" + item.facultyRating.accomplishment + ") "
                          : ""
                      }}
                      {{
                        item.eff_is_rated ? item.facultyRating.efficiency : "NR"
                      }}
                    </template>
                    <template v-slot:[`item.quality`]="{ item }">
                      {{
                        item.qly_is_rated ? item.facultyRating.quality : "NR"
                      }}
                    </template>
                    <template v-slot:[`item.timeliness`]="{ item }">
                      {{
                        item.timeliness_is_rated
                          ? item.facultyRating.timeliness
                          : "NR"
                      }}
                    </template>
                    <template v-slot:[`item.remarks`]="{ item }">
                      {{ item.facultyRating.remarks }}
                    </template>

                    <template
                      v-slot:[`item.action`]="{ item }"
                      v-if="!getIsSubmitted"
                    >
                      <v-btn
                        v-if="
                          targetRating &&
                          targetRating.isSubmitted &&
                          targetRating.assesed_by_status == 3 &&
                          (tab != 3
                            ? hasUnOpennedRemarks(item.pendingRemarks) > 0
                            : false)
                        "
                        x-small
                        class="my-1"
                        @click="showPendingRemarks(item.pendingRemarks)"
                        outlined
                        color="primary"
                        block
                        >Show Remarks</v-btn
                      >
                      <v-btn
                        x-small
                        @click="
                          item.facultyRating.has_added_rating == 0
                            ? addRate(item)
                            : updateRate(item)
                        "
                        outlined
                        block
                        :color="
                          item.facultyRating.has_added_rating == 0
                            ? '#519043'
                            : 'warning'
                        "
                        >{{
                          item.facultyRating.has_added_rating == 0
                            ? "Add"
                            : "Update"
                        }}
                        Rate
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
                <v-col cols="12" class="pt-2 px-4" v-if="tab == 3">
                  <v-form ref="GDriveLinkRef">
                    <div class="pa-4 rounded-lg" style="border: 1px solid grey">
                      <div class="px-2" v-if="!showUpdateLinkBtn">
                        <v-text-field
                          v-model="gdrive_link"
                          outlined
                          color="#519043"
                          :rules="
                            !showUpdateLinkBtn
                              ? [
                                  formRules.required,
                                  formRules.isValidGDriveLink,
                                ]
                              : []
                          "
                          dense
                          placeholder="Paste your GDrive link here"
                        ></v-text-field>
                      </div>
                      <div class="px-2" v-if="!showUpdateLinkBtn">
                        <v-btn
                          v-if="!showUpdateLinkBtn && toUpdateLink"
                          color="red"
                          class="white--text mx-2"
                          @click="undoUpdate()"
                        >
                          undo
                        </v-btn>

                        <v-btn
                          v-if="!showUpdateLinkBtn"
                          color="#519043"
                          class="white--text"
                          @click="saveLink()"
                          :disabled="saveLinkbtn"
                          :loading="saveLinkbtn"
                        >
                          save
                        </v-btn>
                      </div>
                      <div class="px-2" v-if="showUpdateLinkBtn">
                        <v-btn
                          v-if="showUpdateLinkBtn"
                          color="warning"
                          class="white--text mx-2"
                          @click="showGDrive()"
                        >
                          View GDrive
                        </v-btn>

                        <v-btn
                          v-if="showUpdateLinkBtn && !getIsSubmitted"
                          color="#519043"
                          class="white--text"
                          @click="updateLink()"
                        >
                          Update
                        </v-btn>
                      </div>
                    </div>
                  </v-form>
                </v-col>
              </v-row>
              <v-row v-if="getHasData">
                <v-col
                  cols="12"
                  v-if="
                    targetRating &&
                    targetRating.isSubmitted == 1 &&
                    targetRating.assesed_by_status == 2
                  "
                >
                  <v-divider></v-divider>
                  <div class="pa-3">
                    <div class="text-h6">
                      Comments and Recommendations for Development Purposes:
                    </div>
                    <div class="text-justify text-subtitle-1">
                      {{ targetRating ? targetRating.comments : null }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-5">
            <!-- <v-fab-transition>
              <v-menu top>
                <template v-slot:activator="{ on }">
                  <v-btn color="#519043" left outlined v-on="on">
                    Remarks
                  </v-btn>
                </template>

                <v-card class="mx-auto" width="600" max-width="600" elevation-4>
                  <v-card-title class="dialog-header  white--text">
                    <span class="text-h6">Remarks</span>
                  </v-card-title>
                  <v-card-text
                    class="py-0"
                    style="background-color:white;  height : 300px; overflow-y:auto"
                  >
                    <v-timeline dense v-if="remarksData.length > 0">
                      <v-timeline-item
                        v-for="item in remarksData"
                        :key="item.id"
                        small
                        color="#519043"
                        icon="mdi-comment-processing-outline"
                        fill-dot
                      >
                        <v-alert :value="true">
                          <div class="text-h6">
                            {{
                              $store.getters.getUserData.id ==
                              item.remarks_maker_userID
                                ? "You"
                                : item.remarks_by
                            }}
                          </div>
                          <div class="text-body-1">
                            {{ item.message }}
                          </div>
                          <div class="text-caption">
                            <i>{{ formatDate(item.created_at) }}</i>
                          </div>
                        </v-alert>
                      </v-timeline-item>
                    </v-timeline>
                    <v-timeline dense v-if="remarksData.length == 0">
                      <v-timeline-item
                        small
                        color="#519043"
                        icon="mdi-comment-processing-outline"
                        fill-dot
                      >
                        <v-alert :value="true">
                          <div class="text-body-1">
                            No remarks found.
                          </div>
                        </v-alert>
                      </v-timeline-item>
                    </v-timeline>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-fab-transition> -->
            <v-spacer></v-spacer>

            <v-btn
              v-if="shouldSubmit"
              color="#519043"
              class="white--text"
              @click="submit()"
              :disabled="isloading"
              :loading="isloading"
            >
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- delete dialog -->
    <v-dialog
      v-if="confirmSubmitDialog"
      v-model="confirmSubmitDialog"
      persistent
      max-width="390"
    >
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to submit this for approval?
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
          Are you sure you want to proceed?
        </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="confirmBtnLoading"
            color="red"
            outlined
            @click="cancelConfirm()"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="confirmBtnLoading"
            :loading="confirmBtnLoading"
            color="green"
            class="white--text"
            @click="confirmSubmit()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <IPCRFacultySetRatingDialog :action="action" :data="itemData" />
    <ViewRemarksTimelineDialog
      :data="pendingList"
      :viewFrom="'Owner'"
      v-on:closeRemarksTimeline="initialize()"
    />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import ViewRemarksTimelineDialog from "../../Views/ViewRemarksTimelineDialog.vue";

export default {
  components: {
    IPCRFacultySetRatingDialog: () =>
      import("../IPCRFaculty/IPCRFacultySetRatingDialog.vue"),
    ViewRemarksTimelineDialog,
  },
  props: {
    data: null,
  },
  data() {
    return {
      action: null,
      isloading: null,
      confirmSubmitDialog: false,
      pendingList: [],
      confirmBtnLoading: false,
      saveLinkbtn: false,
      gdrive_link: null,
      toUpdateLink: false,
      loading: false,
      remarksData: [],
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      options: {},
      itemData: null,
      expanded: [],
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        { id: 3, name: "Google Drive Link" },
      ],
      ipcr: null,
      curData: null,
      dataItem: [],
      targetRating: null,
      usersList: [],
      ipcr_gDriveLink: null,
      headers: [
        {
          text: "MFO",
          value: "mfo",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "success_indicator",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Efficiency",
          value: "efficiency",
          align: "center",
          width: 200,
          valign: "center",
          sortable: false,
        },
        {
          text: "Quality",
          value: "quality",
          width: 200,
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Timeliness",
          value: "timeliness",
          width: 200,
          align: "center",
          valign: "center",
          sortable: false,
        },
        // {
        //   text: "Status",
        //   value: "approval_status",
        //   align: "center",
        //   valign: "center",
        //   sortable: false,
        // },
        {
          text: "Remarks",
          value: "remarks",
          align: "start",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "end",
          width: 100,
          valign: "center",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    shouldSubmit() {
      if (this.targetRating && this.targetRating.isSubmitted == 0) {
        return true;
      } else {
        if (this.targetRating && this.targetRating.assesed_by_status != 3) {
          return false;
        } else {
          return true;
        }
      }
    },

    getIsSubmitted() {
      if (this.targetRating && this.targetRating.isSubmitted == 1) {
        return this.targetRating.assesed_by_status != 3;
      }

      return false;
    },

    getHasData() {
      return this.dataItem.length > 0;
    },

    showUpdateLinkBtn() {
      let show = false;
      if (this.ipcr_gDriveLink) {
        if (this.toUpdateLink) {
          show = false;
        } else {
          show = true;
        }
      }
      return show;
    },
  },
  watch: {
    data: {
      handler(data) {
        this.getHeadUsers();
        this.tab = 1;
        this.dialog = true;
        this.activeTab = { id: 1, name: "Core Functions" };
        console.log("this is data", data);
        this.ipcr = data;
        this.toUpdateLink = false;
        this.getGDriveLink(data.id);
        this.loadRemarks(data.id);
        this.initialize();
      },
      deep: true,
    },

    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.eventHub.$on("closeIPCRFacultySetRatingDialog", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeIPCRFacultySetRatingDialog");
  },
  methods: {
    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/IPCR-FACULTY-RATING", "GET").then(
          (res) => {
            if (res.data) {
              console.log("remarks", res.data);
              this.remarksData = res.data;
            }
          }
        );
      }
    },

    getGDriveLink(id) {
      if (id) {
        this.axiosCall("/ipcr/getGdriveLink/" + id, "GET").then((res) => {
          if (res.data) {
            console.log("LINK", res.data);
            this.ipcr_gDriveLink = res.data;
          }
        });
      }
    },

    showGDrive() {
      let url = this.ipcr_gDriveLink.link;
      window.open(url, "_blank");
    },
    initialize() {
      this.loading = true;

      this.axiosCall(
        "/ipcr-target/getMyIPCRTargetForRating/" +
          this.ipcr.id +
          "/" +
          this.tab,
        "GET"
      ).then((res) => {
        if (res) {
          console.log("RESPONSE", res.data);
          //   this.curData = res.data;
          this.dataItem = res.data.targets;
          this.targetRating = res.data.target_rating;
          this.loading = false;
        }
      });
    },

    getItemSuccessIndicator(item) {
      return item.efficiency_type == "percentage"
        ? item.efficiency +
            "%" +
            " " +
            item.mfo +
            " " +
            item.quality +
            " " +
            item.timeliness
        : item.efficiency +
            " " +
            item.mfo +
            " " +
            item.quality +
            " " +
            item.timeliness;
    },
    getTotal(field, item) {
      if (item) {
        let i = item.mpor;

        if (field == "E") {
          let total = 0;
          if (item.eff_is_rated) {
            if (
              i.e_w1 != null &&
              i.e_w2 != null &&
              i.e_w3 != null &&
              i.e_w4 != null
            ) {
              total += i ? (i.e_w1 ? i.e_w1 : 0) : 0;
              total += i ? (i.e_w2 ? i.e_w2 : 0) : 0;
              total += i ? (i.e_w3 ? i.e_w3 : 0) : 0;
              total += i ? (i.e_w4 ? i.e_w4 : 0) : 0;
              return total;
            } else {
              return "To be rated";
            }
          } else {
            return "Not to be Rated";
          }
        } else if (field == "Q") {
          let total = 0;
          if (item.qly_is_rated) {
            if (
              i.q_w1 != null &&
              i.q_w2 != null &&
              i.q_w3 != null &&
              i.q_w4 != null
            ) {
              total += i ? (i.q_w1 ? i.q_w1 : 0) : 0;
              total += i ? (i.q_w2 ? i.q_w2 : 0) : 0;
              total += i ? (i.q_w3 ? i.q_w3 : 0) : 0;
              total += i ? (i.q_w4 ? i.q_w4 : 0) : 0;
              return total;
            } else {
              return "To be rated";
            }
          } else {
            return "Not to be Rated";
          }
        } else if (field == "T") {
          let total = 0;
          if (item.timeliness_is_rated) {
            if (
              i.t_w1 != null &&
              i.t_w2 != null &&
              i.t_w3 != null &&
              i.t_w4 != null
            ) {
              total += i ? (i.t_w1 ? i.t_w1 : 0) : 0;
              total += i ? (i.t_w2 ? i.t_w2 : 0) : 0;
              total += i ? (i.t_w3 ? i.t_w3 : 0) : 0;
              total += i ? (i.t_w4 ? i.t_w4 : 0) : 0;
              return total;
            } else {
              return "To be rated";
            }
          } else {
            return "Not to be Rated";
          }
        }
      }
    },
    getName(uID) {
      if (uID) {
        for (let i = 0; i < this.usersList.length; i++) {
          if (uID == this.usersList[i].usID) {
            return this.usersList[i].name;
          }
        }
      }
    },

    closeD() {
      this.eventHub.$emit("closeIPCRFacultyRatingDialog", false);
      this.dialog = false;
    },

    addRate(item) {
      console.log("RATE ITEM", item);
      let setting = {
        mfo: item.mfo,
        target_for: item.target_for,
        eff_is_rated: item.eff_is_rated,
        eff_rating_scale: [],
        qly_is_rated: item.qly_is_rated,
        qly_rating_scale: [],
        timeliness_is_rated: item.timeliness_is_rated,
        timeliness_rating_scale: [],
      };
      if (item.facultyRatingSettings) {
        Object.assign(item.facultyRatingSettings, {
          target_for: item.target_for,
        });
      }
      this.itemData = {
        facultyRating: item.facultyRating,
        facultyRatingSettings: item.facultyRatingSettings
          ? item.facultyRatingSettings
          : setting,
      };
      // console.log("imteData", item);
      this.action = "Add";
    },
    updateRate(item) {
      console.log("RATE ITEM", item);
      let setting = {
        mfo: item.mfo,
        target_for: item.target_for,
        eff_is_rated: item.eff_is_rated,
        eff_rating_scale: [],
        qly_is_rated: item.qly_is_rated,
        qly_rating_scale: [],
        timeliness_is_rated: item.timeliness_is_rated,
        timeliness_rating_scale: [],
      };
      if (item.facultyRatingSettings) {
        Object.assign(item.facultyRatingSettings, {
          target_for: item.target_for,
        });
      }

      this.itemData = {
        facultyRating: item.facultyRating,
        facultyRatingSettings: item.facultyRatingSettings
          ? item.facultyRatingSettings
          : setting,
      };
      this.action = "Update";
    },
    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    submit() {
      this.confirmSubmitDialog = true;
    },
    setPendingClass(item) {
      if (this.targetRating.assesed_by_status == 3) {
        if (this.tab != 3) {
          let list = item.pendingRemarks;
          let has = false;
          if (list) {
            for (let i = 0; i < list.length; i++) {
              if (list[i].isOpenned == 0) {
                has = true;
                break;
              }
            }
            if (has) {
              return "red lighten-4";
            }
          }
          return "";
        }
      }
      return "";
    },

    hasUnOpennedRemarks(list) {
      if (list && list.length > 0) {
        let has = false;
        for (let i = 0; i < list.length; i++) {
          if (list[i].isOpenned == 0) {
            has = true;
            break;
          }
        }
        if (has) {
          return has;
        } else {
          if (
            this.targetRating.assesed_by_status != 2 &&
            this.targetRating.isSubmitted
          ) {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    showPendingRemarks(item) {
      this.pendingList = [];
      setTimeout(() => {
        this.pendingList = item;
      }, 100);
    },

    saveLink() {
      this.saveLinkbtn = true;
      if (this.$refs.GDriveLinkRef.validate()) {
        if (this.gdrive_link && this.ipcr) {
          let data = {
            id: this.ipcr_gDriveLink ? this.ipcr_gDriveLink.id : null,
            link: this.gdrive_link,
          };
          this.axiosCall(
            "/ipcr/setFacultyIPCRGDriveLink/" + this.ipcr.id,
            "PATCH",
            data
          ).then((res) => {
            if (res.data.status == 200) {
              this.saveLinkbtn = false;

              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.getGDriveLink(this.ipcr.id);
            } else {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          });
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message =
            "Please paste the link of your Google Drive as attachments.";
        }
      } else {
        this.saveLinkbtn = false;
      }
    },

    updateLink() {
      this.toUpdateLink = true;
    },

    undoUpdate() {
      this.gdrive_link = null;
      this.toUpdateLink = false;
    },

    cancelConfirm() {
      this.confirmSubmitDialog = false;
    },
    confirmSubmit() {
      this.confirmBtnLoading = true;

      this.axiosCall(
        "/ipcr-target/submitIpcrFacultyRating/" + this.targetRating.id,
        "PATCH"
      ).then((res) => {
        if (res) {
          this.confirmBtnLoading = false;

          if (res.data.status == 200) {
            this.confirmSubmitDialog = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.initialize();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        }
      });
    },

    getHeadUsers() {
      this.axiosCall(
        "/user-details/getUsersHeadProgChairAbove_Office",
        "GET"
      ).then((res) => {
        let data = res.data;
        data.forEach((element, i) => {
          data[i].name = this.toTitleCase(element.name);
        });
        this.usersList = data;
      });
    },
  },
};
</script>
<style scoped>
#tbl_expanded {
  border-collapse: collapse;
  width: 100%;
  padding: 5px;
}
#tbl_expanded table,
#tbl_expanded th,
#tbl_expanded td {
  border: 2px solid grey;
}
</style>
